import axios from "axios";

// Use environment variable for production, fallback to local development URL
const BASE_URL = process.env.REACT_APP_BASE_URL;

// API endpoints
export const fetchCarTypes = () => axios.get(`${BASE_URL}/car-types`);
export const fetchServices = () => axios.get(`${BASE_URL}/services`);
export const fetchProducts = () => axios.get(`${BASE_URL}/offers`);

// Contact API endpoints
export const fetchContacts = () => axios.get(`${BASE_URL}/contacts`);
export const submitContactForm = (contactData) =>
  axios.post(`${BASE_URL}/contact`, contactData);
export const fetchTestimonials = () => axios.get(`${BASE_URL}/testimonials`);

// Add a new testimonial
export const addTestimonial = (testimonial) =>
  axios.post(`${BASE_URL}/testimonials`, testimonial);

// Reservation API endpoints
export const addReservation = async (reservationData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/reservations`,
      reservationData
    );
    return response.data;
  } catch (error) {
    console.error("Error adding reservation:", error);
    throw error;
  }
};

export const fetchReservations = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/reservations`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reservations:", error);
    throw error;
  }
};
// Update an existing reservation
export const updateReservation = (reservationId, updatedData) =>
  axios.put(
    `${BASE_URL}/reservations/${reservationId}`,
    updatedData
  );

// User API endpoints
export const registerUser = (userData) =>
  axios.post(`${BASE_URL}/users/register`, userData);
export const loginUser = (loginData) =>
  axios.post(`${BASE_URL}/users/login`, loginData);
export const activateUser = (userId) =>
  axios.put(`${BASE_URL}/users/activate/${userId}`);

// Admin-only User Management API endpoints
export const fetchUsers = () => axios.get(`${BASE_URL}/users`);
export const deleteUser = (userId) =>
  axios.delete(`${BASE_URL}/users/${userId}`);

export const replyToContact = async (emailData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${BASE_URL}/contacts/reply`,
      emailData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Include token if required
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error sending reply email:", error);
    throw error;
  }
};
export const fetchQuotes = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/quotes`);
    return response.data;
  } catch (error) {
    console.error("Error fetching quotes:", error);
    throw error;
  }
};

// Create a new quote
export const createQuote = async (quoteData) => {
  try {
    const response = await axios.post(`${BASE_URL}/quotes`, quoteData);
    return response.data;
  } catch (error) {
    console.error("Error creating quote:", error);
    throw error;
  }
};
